/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */

import config from "@/config";
import axios from "axios";
import store from "@/store";

export default {
	getSchedulerProjectedEvents({stationID, params}) {
		return axios.get(
			`${config.SCHEDULER_URL}/api/v1/subscribers/${stationID}/projected_events`,
			{
				params,
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	getSchedulerSubscriptions(stationID) {
		return axios.get(`${config.SCHEDULER_URL}/api/v1/subscribers/${stationID}/subscriptions`, {
			headers: {
				"Authorization": store.getters.getAccessToken()
			}
		});
	},

	createEventOverride(payload) {
		return axios.post(
			`${config.SCHEDULER_URL}/api/v1/subscribers/${payload.subscriber_id}/event_overrides`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	updateEventOverride(payload) {
		return axios.put(
			`${config.SCHEDULER_URL}/api/v1/subscribers/${payload.subscriber_id}/event_overrides/${payload.id}`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	cancelEvent(params) {
		return axios.post(
			`${config.SCHEDULER_URL}/api/v1/subscribers/${params.subscriber_id}/event_overrides/${params.id}/cancel`,
			null,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	restoreEvent(params) {
		return axios.post(
			`${config.SCHEDULER_URL}/api/v1/subscribers/${params.subscriber_id}/event_overrides/${params.id}/restore`,
			null,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	updateScheduleEvent(payload) {
		return axios.put(
			`${config.SCHEDULER_URL}/api/v1/objects/${payload.object_id}/schedules/${payload.schedule_id}/events/${payload.id}`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	}
}
